import { createSlice } from "@reduxjs/toolkit"

export type Donation = {
  beneficiaryId: string
  amount: string
  timestamp: number
  transactionHash: string
}

type DonationState = {
  donationsHistory: Donation[]
  isDonationHistoryFetching: boolean
}

const initialState: DonationState = {
  donationsHistory: [],
  isDonationHistoryFetching: true,
}

const donationSlice = createSlice({
  name: "donation",
  initialState,
  reducers: {
    // Adds new items from the payload to the current donation history
    mergeDonationsHistory: (
      immerState,
      { payload: incoming }: { payload: Donation[] },
    ) => {
      if (immerState.donationsHistory.length === 0) {
        immerState.donationsHistory = incoming
        return
      }

      const merged = [
        ...incoming.filter(
          (incomingDonation) =>
            !immerState.donationsHistory.some(
              (donation) =>
                donation.transactionHash === incomingDonation.transactionHash,
            ),
        ),
        ...immerState.donationsHistory,
      ] as Donation[]

      immerState.donationsHistory = merged
    },
    addNewDonationToHistory: (
      immerState,
      { payload }: { payload: Donation },
    ) => {
      immerState.donationsHistory = [payload, ...immerState.donationsHistory]
    },
    setIsDonationHistoryFetching: (
      immerState,
      { payload }: { payload: boolean },
    ) => {
      immerState.isDonationHistoryFetching = payload
    },
    resetDonationState: (_) => initialState,
  },
})

export const {
  mergeDonationsHistory,
  addNewDonationToHistory,
  setIsDonationHistoryFetching,
  resetDonationState,
} = donationSlice.actions

export default donationSlice.reducer
